<!-- Container -->
<div class="container">

  <ul>
    <li>
      Use "My Profile" from the main menu to change the name, phone number, or email associated with the account
    </li>
  </ul>

</div>
